import React, { useState, useEffect, useRef } from "react";
import SvgIcon from "../../../../parts/SvgIcon";
import submit from "submit-form";

const SelectGroupsForMobileScreen = ({
  clientWord,
  classNames,
  query,
  options,
}) => {
  const divRef = useRef(null);
  const [isUnfolded, setIsUnfolded] = useState(false);

  /**
   * Listener to close the modal if the user clicks outside the div
   */
  useEffect(() => {
    // Function to handle clicks anywhere on the document
    function handleClickOutside(event) {
      if (divRef.current && !divRef.current.contains(event.target)) {
        setIsUnfolded(false);
      }
    }

    // Add the click listener to the document
    document.addEventListener("click", handleClickOutside);

    return () => {
      // Remove the click listener when the component unmounts
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const selectGroup = (e, group) => {
    e.stopPropagation();
    e.preventDefault();
    const body =
      group === "open-new-group-modal"
        ? {
            "modal[type]": "new-group",
            filterGroup: "",
          }
        : {
            filterGroup: group,
          };

    submit(`/actions/refresh/?`, {
      method: "GET",
      body,
    });
  };

  return (
    <details
      ref={divRef}
      role="list"
      open
      className={`dropdown-img select-group-mobile ${classNames}`}
    >
      <summary
        onClick={(e) => {
          e.preventDefault();
          setIsUnfolded(!isUnfolded);
        }}
      >
        {query && query.filterGroup ? (
          <p>
            {query.filterGroup === "all"
              ? `All ${clientWord}`
              : query.filterGroup === "organization"
              ? `All Organization ${clientWord}`
              : query.filterGroup}
          </p>
        ) : (
          <p>Group Name</p>
        )}
        <SvgIcon
          src={isUnfolded ? "/img/svg/angle-up.svg" : "/img/svg/angle-down.svg"}
        />
      </summary>
      <ul className={isUnfolded ? "opened" : ""}>
        {options.map((group) => {
          const { text, value } = group;
          return (
            <li
              key={value}
              onClick={(e) => {
                setIsUnfolded(!isUnfolded);
                selectGroup(e, value);
              }}
            >
              <span>{text}</span>
            </li>
          );
        })}
        <li
          key="new-group"
          className="new-group"
          onClick={(e) => {
            setIsUnfolded(!isUnfolded);
            selectGroup(e, "open-new-group-modal");
          }}
        >
          <SvgIcon
            classNames="icon-red"
            src="/img/new-icons/add-gradient-icon.svg"
            alt="add group"
          />
          <span className="clipped">Add Category</span>
        </li>
      </ul>
    </details>
  );
};

export default SelectGroupsForMobileScreen;
